export default __webpack_public_path__ + "static/media/logo.021c895c.jpeg";